export default "__VITE_ASSET__SSx$MEVE__"